// src/axios.js
// import axios from 'axios';
// import store from './store/index'
// import i18n from './i18n'
// import Cookies from 'js-cookie';
// import router from "@/router";


import {checkEnv} from "@/utils/FPUser";
import { InitFingerprint } from "./utils/CommonoUtils";

let recommit_number = 0;

const mode = 'mode=sandbox';

// 测试环境 推荐列表等需要加上mode
let ENV_TEST = false;


let LOGIN_URL = "https://familypro.io/user/login"
let BASE_URL = 'https://familypro.io/'

const env = checkEnv();

if (['location', 'sandbox'].includes(env)) {
    ENV_TEST = true;
    LOGIN_URL = "https://dev.familypro.io/user/login"
    if (env === 'location') {
        BASE_URL = 'http://localhost:8000';
    } else {
        BASE_URL = 'https://dev.familypro.io/';
    }
    console.log("BASE_URL:", BASE_URL);
    console.log("当前环境变量:", env);
    console.log("初始化axios");
    console.log("当前环境变量 VUE_APP_ENV:", process.env.VUE_APP_ENV);
}

let axios;


if (process.env.VUE_APP_ENV === 'development') {
    console.log("获取本地 axios");
    axios = require('axios');
    globalThis.axios = axios;
} else {
    // console.log("获取 cdn axios");
    axios = window.axios;
    globalThis.axios = axios;
}

const instance = axios.create({
    baseURL: BASE_URL, // 替换为你的 API 地址
    // baseURL: '/', // 替换为你的 API 地址
    timeout: 100000, headers: {'Content-Type': 'application/json', 'mode': 'production'}
});

function getLanguageInfo(Cookies) {
    let language = Cookies.get('sbox-l')
    let headerLanguage = "en-US";
    switch (language) {
        case "cn":
            headerLanguage = 'zh-CN';
            break;
        case "es":
            headerLanguage = "es-ES";
            break;
        case "fr":
            headerLanguage = "fr-FR";
            break;
        case "ko":
            headerLanguage = "ko-KR";
            break;
        case "de":
            headerLanguage = "de-DE";
            break;
        case "ru":
            headerLanguage = "ru-RU";
            break;
        case "it":
            headerLanguage = "it-IT";
            break;
        case "jp":
            headerLanguage = "ja-JP";
            break;
        case "br":
            headerLanguage = "pt-PT";
            break;
        default:
            headerLanguage = "en-US";
    }
    return headerLanguage;
}

// 你可以在这里添加拦截器
export function injectOtherRequestComponent(store, Cookies, i18n) {
    instance.interceptors.request.use(async config => {
        // 在发送请求之前做些什么
        const urlRequiringToken = [
            'api/order/',
            '/api/renewal_order',
            '/api/admin/put-goods',
            '/api/user-center',
            '/api/v1/verifications',
            "/api/admin",
        ];
    
        //  如果url 是 "/api/products/discount-info"
        if (config.url.includes("/api/products/discount-info")) {
            try {
                const tokenJson = store.state.auth.token
                if (tokenJson === null || tokenJson === undefined) {
                    return config;
                }
                const tokenObj = JSON.parse(tokenJson);
                const token = tokenObj.token
                config.headers.Authorization = token
            } catch (e) {
                console.log("tokenJson error:", e);
            }
        }


        if (urlRequiringToken.some(url => config.url.includes(url))) {
            if (store.state.auth.token === null || store.state.auth.token === 0) {
                await userLogin(store, i18n);
            }
            let tokenJson = store.state.auth.token
            let token = null
            let expirationTime = null
            try {
                const tokenObj = JSON.parse(tokenJson);
                token = tokenObj.token
                expirationTime = tokenObj.expirationTime
            } catch (e) {
                token = tokenJson
            }
            // 获取当前零时区的时间戳，单位为秒
            const currentTime = Math.floor(Date.UTC(
                new Date().getUTCFullYear(),
                new Date().getUTCMonth(),
                new Date().getUTCDate(),
                new Date().getUTCHours(),
                new Date().getUTCMinutes(),
                new Date().getUTCSeconds(),
                0
            ) / 1000);
            console.log("当前时间：", currentTime);
            console.log("过期时间：", expirationTime);
            console.log("expirationTime < currentTime", expirationTime < currentTime);
            if (expirationTime !== null && expirationTime < currentTime) {
                // token过期失效
                store.dispatch('removeUserInfo');
                store.dispatch('removeTokenStore');
                // 刷新toke
                await userLogin(store, i18n);
                try {
                    tokenJson = store.state.auth.token
                    const tokenObj = JSON.parse(tokenJson);
                    token = tokenObj.token
                    expirationTime = tokenObj.expirationTime
                } catch (e) {
                    token = tokenJson
                }
            }
            config.headers.Authorization = token
        }
        config.headers.Language = getLanguageInfo(Cookies);
        if (ENV_TEST) {
            const testSpecialHandlingUrl = [
                'api/goods/recommend-list',
                'api/goods/price-list',
                'api/user-center/user-center-info',
                'api/admin/put-goods'
            ]
            if (testSpecialHandlingUrl.some(url => config.url.includes(url))) {
                if (config.method === 'get') {
                    if (config.url.includes("?")) {
                        config.url = config.url + "&" + mode;
                    } else {
                        config.url = config.url + "?" + mode;
                    }
                }
            }

        }
        const visitor_id = await InitFingerprint();
        config.headers.visitorId = visitor_id;
        // 环境变量传递到后端
        config.headers.mode = process.env.VUE_APP_MODE;
        return config;
    }, error => {
        console.log("请求错误: ", error)
        // 处理请求错误
        return Promise.reject(error);
    });
}

export function injectOtherResponseComponent(store) {
    instance.interceptors.response.use(async response => {
        // 处理响应数据
        let token = response.headers['x-auth-token'];
        let expirationTime = response.headers['expiration-time']
        if (token !== null && token !== undefined) {
            // 替换token
            let json_token = JSON.stringify({token: token, expirationTime: expirationTime})
            store.dispatch('updateTokenStore', json_token)
        }
        return response;
    }, error => {
        if (error.config) {
            console.log("请求接口: " + error.config.url + " 错误响应数据：", error);
        } else {
            console.log("请求发生错误，没有请求配置", error);
        }
        // 关闭打开的弹窗
        if (window.openwindow) {
            window.openwindow.close();
            window.openwindow = null; // 清除引用
        }
        // 处理响应错误
        if (error.response) {
            if (error.response.status === 401 && !error.config.url.includes("/api/products/discount-info")) {
                // 未登录或登录失效
                store.dispatch('removeUserInfo');
                store.dispatch('removeTokenStore');
                window.location.href = LOGIN_URL; // 重定向到登录页面
            } else if (error.response.status === 403) {
                // 无权限访问
            }
            if (error.response.data.code === 109001) {
                console.log("请求失败", error.response.data.message);
            }
            if (error.response.data.code === 100002) {
                if (window.openwindow) {
                    window.openwindow.close();
                    window.openwindow = null; // 清除引用
                }
            }
            if (error.response) {
                console.log('Response error:', error.response.data);
            } else if (error.request) {
                console.log('Request error:', error.request);
            } else {
                console.log('Error:', error.message);
            }
        }
        return Promise.reject(error);
    });

}

// console.log("axios初始化完成")

async function userLogin(store, i18n) {
    const FPUserUtils = await import('@/utils/FPUser')
    let userInfo = await FPUserUtils.getUserInfo();
    if (userInfo == null) {
        if (window.openwindow) {
            window.openwindow.close();
            window.openwindow = null; // 清除引用
        }
        store.dispatch('removeUserInfo');
        store.dispatch('removeTokenStore');
        window.location.href = LOGIN_URL;
        throw new Error(i18n.global.t('console.log_in'));
    }
    // store.dispatch('updateUserInfoStore', userInfo)
    let tokenStr = await FPUserUtils.login(userInfo, null);
    if (tokenStr == null) {
        if (window.openwindow) {
            window.openwindow.close();
            window.openwindow = null; // 清除引用
        }
        store.dispatch('removeUserInfo');
        store.dispatch('removeTokenStore');
    }
    store.dispatch('updateTokenStore', tokenStr)
}

export default instance;
